import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { debounceTime, distinctUntilChanged, switchMap, catchError, of } from 'rxjs';
import { AlertComponent } from 'src/app/modules/components/alert/alert.component';
import { LoadingService } from 'src/app/modules/components/loading/loading.service';
import { ModalComponent } from 'src/app/modules/components/modal/modal.component';
import { FormatUtilsService } from 'src/app/modules/services/format-utils/format-utils.service';

import { RelatoriosContratuaisService } from 'src/app/modules/services/relatorios-contratuais/relatorios-contratuais.service';
import { ToastService } from 'src/app/modules/services/toast/toast.service';

@Component({
  selector: 'app-modal-vincular-relatorio',
  templateUrl: './modal-vincular-relatorio.component.html',
  styleUrls: ['./modal-vincular-relatorio.component.scss']
})
export class ModalVincularRelatorioComponent {
  screenWidth: number = window.innerWidth;
  contractId: any;
  sortState = {
    sortProperty: 'relatorio.nome',
    sortDirection: 'asc'
  };
  columnConfig = [
    { columnDef: 'contrato', header: 'Contrato', property: 'contrato.contractNumber', customTd: true },
    { columnDef: 'relatorio', header: 'Nome do relatório', property: 'relatorio.nome' },
    { columnDef: 'prazo', header: 'Prazo', property: 'prazo', customTd: true },
    { columnDef: 'actions', header: 'Ações', custom: true }
  ];

  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = [];
  pageIndex = 0;
  pageSize = 10;
  totalPages = 1;
  totalElements = 0;

  // ========== Form Controls: Contratos ==========
  searchControl = new FormControl();
  filteredOptions: any[] = [];
  selectedOption: any;

  constructor(
    public toastService: ToastService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private loadingService: LoadingService,
    private formatUtilsService: FormatUtilsService,
    private dialogRef: MatDialogRef<ModalVincularRelatorioComponent>,
    private relatoriosContratuaisService: RelatoriosContratuaisService,
    @Inject(MAT_DIALOG_DATA) public data:any
  ) { 
      this.displayedColumns = this.columnConfig.map(col => col.columnDef);
    this.contractId = this.data.contractId;
    if(this.data.dataSource){
      this.dataSource.data = [...this.data.dataSource];
    }
    this.setupSearchSubscriptions();
  }

   private setupSearchSubscriptions(): void {
    this.setupRelatoriosSearch();
  }

  private setupRelatoriosSearch(): void {
    this.searchControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(value =>
        this.relatoriosContratuaisService.getRelatoriosAtestados(
          10,
          0,
          'asc',
          'relatorio.nome',
          value.trim()
        ).pipe(
          catchError(() => of([]))
        )
      )
    ).subscribe((results: any) => {
      this.filteredOptions = results.content;
    });
  }
  onOptionSelected(event: any) {
    this.selectedOption = event.option.value;
 
    const novoElemento = this.selectedOption;
    const dados = this.dataSource.data;

    // Verifica se já existe um elemento com o mesmo ID
    const existe = dados.some(item => item.id === novoElemento.id);

    if (existe) {
      this.openSnackBar('Relatório já adicionado anteriormente.', 'warning');
        this.searchControl.setValue(null, { emitEvent: false });
    this.selectedOption = null;
      return; // Impede a adição
    }
    // Adiciona e atualiza o dataSource
    this.dataSource.data = [...dados, novoElemento];
    this.searchControl.setValue(null, { emitEvent: false });
    this.selectedOption = null;
    
  }
  // === SUBMISSÃO DE DADOS PARA TRANSIÇÃO DE STATUS ===
  onSubmit(): void {
    this.dialogRef.close(this.dataSource.data);
  }

  // === CANCELA E FECHA MODAL ===
  cancel(): void {
    this.dialogRef.close();
  }
   openSnackBar(description: string, type: string) {
      let classSnack = '';
      switch (type) {
        case 'sucess':
          classSnack = 'snacbar-sucess';
          break;
        case 'warning':
          classSnack = 'snacbar-warning';
          break;
        case 'error':
          classSnack = 'snacbar-error';
          break;
      }
      this._snackBar.openFromComponent(AlertComponent, {
        duration: 3000,
        panelClass: [classSnack, 'snackbar-custom'],
        data: { description: description, type: type },
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
    }
      openDeleteDialog(id: any): void {
        const modalTitle: string = 'Excluir';
        const modalContent: string =
          'Você tem certeza que deseja excluir este Relatório?';
    
        const dialogRef = this.dialog.open(ModalComponent, {
          data: {
            onPerformAction: this.onDeleteModalConfirm.bind(this),
            modalTitle: modalTitle,
            modalContent: modalContent,
            id: id,
          },
        });
      }
        onDeleteModalConfirm(id: any): void {
    const dados = this.dataSource.data;

    // Verifica se o elemento existe
    const existe = dados.some(item => item.id === id);

    if (!existe) {
      this.openSnackBar('Relatório não encontrado.', 'warning');
      return; // Impede a exclusão
    }

    // Remove o elemento e atualiza o dataSource
    this.dataSource.data = dados.filter(item => item.id !== id);
    this.openSnackBar('Relatório deletado com sucesso.', 'sucess');
  }
  
}
